module.exports = __webpack_public_path__ + "static/media/PlutoBold.89a2e44d.ttf";